import { createContext, useState, useEffect, useRef } from "react";
import useAxios from "../customHooks/useAxios";
import useRequest from "../customHooks/useRequest";
import {
  ReadChannel,
  ReadChannelContent,
  ReadPagingChannelContent,
} from "../services/channelService";
const ChatContext = createContext({});

export const ChatProvider = ({ children }) => {
  const controller = new AbortController();
  const requestInterval = useRef(null);
  const isWorkingRef = useRef(false);
  const {response, fetchData, loading} = useAxios();
  const [isSidebarRequest, setIsSidebarRequest] = useState(false);
  const [requestType, setRequestType] = useState("");
  const request = useRequest();
  const [chatState, setChatState] = useState({
    currentTab: "CHANNELS",
    search: "",
  });
  const setChatContext = (name, value) => {
    setChatState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const removeChatContext = (name) => {
    setChatState((prevData) => {
      const newData = { ...prevData };
      delete newData[name];
      return newData;
    });
  };
  const handleResponse = async (res, type) => {
    switch (type) {
      case "READCHANNELS":
      case "READPAGINGCHANNELS":
        setChatState((prevState) => ({
          ...prevState,
          CHANNELS: res.Record,
          channelPaging: res.Paging,
          channelFlt: res.Filter,
        }));
        break;
      case "DELETECHANNEL":
        if (requestInterval.current) {
          clearInterval(requestInterval.current);
          requestInterval.current = null;
        }
        removeChatContext("selectedChat");
        isWorkingRef.current = true;
        readPagingChannel();
        break;
      case "READCHANNELCONTENT":
        isWorkingRef.current = false;
        setChatState((prevState) => ({
          ...prevState,
          CHATCONTENT: res.Record,
          chatPaging: res.Paging,
          chatFlt: res.Filter,
          pinnedMessage: res.PinnedMessage,
        }));
        if (requestInterval.current) {
          await clearInterval(requestInterval.current);
          requestInterval.current = null;
        }
        const interval = setInterval(() => {
          if (!isWorkingRef.current) {
            readPagingChannelContent(res.Filter, res.Paging);
          }
        }, 5000);
        requestInterval.current = interval;
        break;
      case "READPAGINGCHANNELCONTENT":
        isWorkingRef.current = false;
        setChatState((prevState) => ({
          ...prevState,
          CHATCONTENT: res.Record,
          chatPaging: res.Paging,
          chatFlt: res.Filter,
          pinnedMessage: res.PinnedMessage,
        }));
        if (!requestInterval.current) {
          const interval = setInterval(() => {
            if (!isWorkingRef.current) {
              readPagingChannelContent(res.Filter, res.Paging);
            }
          }, 5000);
          requestInterval.current = interval;
        }
        break;
      case "CREATECHANNELCONTENT":
        isWorkingRef.current = false;
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    response && handleResponse(response, requestType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);
  const readPagingChannel = (flt) => {
    setRequestType("READPAGINGCHANNELS");
    setIsSidebarRequest(true);

    // fetchData({
    //   method: "POST",
    //   url: ReadPaging,
    //   headers: request,
    //   signal: controller.signal,
    //   data: {
    //     Paging: chatState.channelPaging && chatState.channelPaging,
    //     Filter: flt ? flt : chatState.channelFlt && chatState.channelFlt,
    //   },
    // });
  };
  const readChannels = () => {
    setRequestType("READCHANNELS");
    setIsSidebarRequest(true);
    setChatState((prevState) => ({
      ...prevState,
    }));
    fetchData({
      method: "POST",
      url: ReadChannel,
      headers: request,
      signal: controller.signal,
    });
  };
  const deleteChannel = () => {
    setRequestType("DELETECHANNEL");
    setIsSidebarRequest(true);
    // fetchData({
    //   method: "POST",
    //   url: Delete,
    //   headers: request,
    //   signal: controller.signal,
    //   data: {
    //     Id: chatState.selectedChat?.Id,
    //   },
    // });
  };
  const readPagingChannelContent = (flt, paging) => {
    if(!chatState.selectedChat?.Id){
      return clearRequestInterval
    }
    setRequestType("READPAGINGCHANNELCONTENT");
    setIsSidebarRequest(false);
    isWorkingRef.current = true;
    fetchData({
      method: "POST",
      url: ReadPagingChannelContent,
      headers: request,
      signal: controller.signal,
      data: {
        Channel_Id: chatState.selectedChat?.Id,
        Paging: paging ? paging : chatState.chatPaging && chatState.chatPaging,
        Filter: flt ? flt : chatState.chatFlt && chatState.chatFlt,
      },
    });
  };
  const clearRequestInterval = async () => {
    if (requestInterval.current) {
      await clearInterval(requestInterval.current);
      requestInterval.current = null;
    }
  };
  const selectChannel = async (channel) => {
    if (requestInterval.current) {
      await clearInterval(requestInterval.current);
      requestInterval.current = null;
    }
    
    // controller.abort();
    setChatState((prevData) => {
      const newData = { ...prevData };
      delete newData.CHATCONTENT;
      delete newData.chatPaging;
      delete newData.chatFlt;
      delete newData.ReplyTo;
      delete newData.pinnedMessage;

      return newData;
    });
    setChatState((prevState) => ({
      ...prevState,
      selectedChat: channel,
    }));

    setIsSidebarRequest(false);
    isWorkingRef.current = true;
    setRequestType("READCHANNELCONTENT");
    fetchData({
      method: "POST",
      url: ReadChannelContent,
      headers: request,
      signal: controller.signal,
      data: {
        Id: channel?.Id,
      },
    });
  };

  return (
    <ChatContext.Provider
      value={{
        chatState,
        loading,
        isSidebarRequest,
        setChatContext,
        removeChatContext,
        readChannels,
        readPagingChannel,
        deleteChannel,
        selectChannel,
        readPagingChannelContent,
        setChatState,
        isWorkingRef,
        clearRequestInterval,
        controller,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};

export default ChatContext;
